import React from 'react';

const About = () => {
  return (
    <div className="p-4 sm:p-6">
      <h1 className="text-2xl sm:text-3xl font-bold text-gray-800 mb-4">About SmartAuditx</h1>
      <p className="text-sm sm:text-base text-gray-600 mb-4">
        Welcome to <strong>SmartAuditx</strong>, your trusted platform for empowering internal auditors with the knowledge and tools they need to succeed. Our mission is to create a free and accessible resource hub where auditors can enhance their skills, discover best practices, and access cutting-edge solutions to streamline their audit processes.
      </p>

      <h2 className="text-xl sm:text-2xl font-semibold text-gray-800 mb-2">Our Mission</h2>
      <p className="text-sm sm:text-base text-gray-600 mb-4">
        At SmartAuditx, we believe in fostering a culture of continuous learning and improvement within the audit community. Our goal is to provide auditors with:
      </p>
      <ul className="list-disc pl-6 text-sm sm:text-base text-gray-600 mb-4">
        <li>Comprehensive learning materials, including videos, podcasts, and certifications.</li>
        <li>Ready-to-use templates, toolkits, and frameworks to simplify audit tasks.</li>
        <li>AI-powered tools to drive efficiency and innovation in audit practices.</li>
      </ul>

      <h2 className="text-xl sm:text-2xl font-semibold text-gray-800 mb-2">Why Choose SmartAuditx?</h2>
      <p className="text-sm sm:text-base text-gray-600 mb-4">
        Our platform is designed with simplicity and effectiveness in mind. Whether you're a seasoned auditor or just starting your journey, SmartAuditx offers a variety of resources tailored to your needs. From industry best practices to automation tools, we've got you covered.
      </p>

      <h2 className="text-xl sm:text-2xl font-semibold text-gray-800 mb-2">Join the Community</h2>
      <p className="text-sm sm:text-base text-gray-600">
        Be part of a growing network of professionals who are shaping the future of internal auditing. Explore our resources, connect with experts, and take your skills to the next level with SmartAuditx.
      </p>
    </div>
  );
};

export default About;
